import React, { createContext, useContext, useState, ReactNode } from "react";
import { ContractData } from "../../types";


/**
 * CarSharingContext
 *
 * Contesto condiviso per i componenti del modulo CarSharing.
 *
 * Inizializzato da: CustomerBaseCarSharingStatus
 *
 */

export interface CarSharingContextType {
    personId?: number;
    contractId?: number;
    csCustomerId?: string;
    market?: string;
    language?: string;
    contractData?: ContractData[];
    isModDataAvailable?: boolean;

    setPersonId?: (id?: number) => void;
    setContractId?: (id?: number) => void;
    setCsCustomerId?: (id?: string) => void;
    setMarket?: (value?: string) => void;
    setLanguage?: (value?: string) => void;
    setContractData?: (value?: ContractData[]) => void;
    setIsModDataAvailable?: (value: boolean) => void;
}

export const CarSharingContext = createContext<CarSharingContextType>({});

export const useCarSharingContext = () => useContext(CarSharingContext);

export const CarSharingProvider = ({ children }: { children: ReactNode }) => {
    const [personId, setPersonId] = useState<number | undefined>(undefined);
    const [contractId, setContractId] = useState<number | undefined>(undefined);
    const [csCustomerId, setCsCustomerId] = useState<string | undefined>(undefined);
    const [market, setMarket] = useState<string | undefined>(undefined);
    const [language, setLanguage] = useState<string | undefined>(undefined);
    const [contractData, setContractData] = useState<ContractData[] | undefined>(undefined);
    const [isModDataAvailable, setIsModDataAvailable] = useState<boolean>(true);


    return (
        <CarSharingContext.Provider
            value={{
                personId,
                contractId,
                csCustomerId,
                market,
                language,
                contractData,
                isModDataAvailable,
                setPersonId,
                setContractId,
                setCsCustomerId,
                setMarket,
                setLanguage,
                setContractData,
                setIsModDataAvailable
            }}
        >
            {children}
        </CarSharingContext.Provider>
    );
};
